__turbopack_context__.v({
  "boostedTagIcon": "-uBr6q_boostedTagIcon",
  "boostedTagText": "-uBr6q_boostedTagText",
  "gradientOverlay": "-uBr6q_gradientOverlay",
  "priceContainer": "-uBr6q_priceContainer",
  "productAttributesContainer": "-uBr6q_productAttributesContainer",
  "soldText": "-uBr6q_soldText",
  "translucentHoverOverlay": "-uBr6q_translucentHoverOverlay",
});
